import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto'
import { mutationTypes as mutation } from './mutations'

const GET_BY_ID = 'getRegulationById'
const SET_REGULATION_OPEN = 'setRegulationOpen'

export const actionTypes = {
  GET_BY_ID,
  SET_REGULATION_OPEN
}

export const actions = {
  [GET_BY_ID] ({ commit }, payload) {
    return RegulationAutoRepository.GetById(payload)
      .then((response) => {
        commit(mutation.SET_REGULATION, response.data.data)
      })
      .catch(() => {
      })
  },
  [SET_REGULATION_OPEN] ({ commit }, payload) {
    commit(mutation.SET_REGULATION, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/regulation/actions.js